import { useState } from "react";
import { auth } from "../firebase";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./SignupPage.css"; // reuse styling

function SignInPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleEmailLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/games");
    } catch (error) {
      alert("Login failed: " + error.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate("/games");
    } catch (error) {
      alert("Google Sign-In failed: " + error.message);
    }
  };

  return (
    <div className="signup-page-wrapper">
      <nav className="navbar">
        <div className="logo">Pinoy Games</div>

        {/* Burger Icon */}
        <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Menu */}
        <ul className={`menu ${menuOpen ? "menu-open" : ""}`}>
          <li><a href="/signup" onClick={() => setMenuOpen(false)}>Sign Up</a></li>
        </ul>
      </nav>

      <div className="signup-container">
        <div className="signup-card">
          <h2>Sign In</h2>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button onClick={handleEmailLogin}>Sign In</button>

          <div className="or-separator">or</div>
          <button className="google-btn" onClick={handleGoogleLogin}>
            Continue with Google
          </button>
          <div className="signup-redirect">
  <span>Don't have an account?</span>
  <a href="/signup">Sign Up</a>
</div>


        </div>
      </div>
    </div>
  );
}

export default SignInPage;
